<template>
  <div class="scpPage">
    <div class="secondOperation">
      <div>
        <i-button @click="getServiceInfo">
          <i class="iconfont icon-refresh"></i>
          刷新
        </i-button>
        <i-button
          @click="showLog = true"
          style="margin-left: 15px"
          type="primary"
        >
          查看日志
        </i-button>
      </div>
      <div style="display: flex; align-items: center">
        <i-switch
          v-model="isOpen"
          @on-change="changeSwitch"
          size="small"
          style="margin: 8px 20px 0 0px"
        ></i-switch>
        <div class="status">
          {{
            result.serviceStatus == 10
              ? "启 用"
              : result.serviceStatus == 11
              ? "启 用 中"
              : result.serviceStatus == 21
              ? "禁 用 中"
              : "禁 用"
          }}
        </div>
      </div>
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        QA服务基本信息
      </div>
      <!-- <div style="display: flex; justify-content: space-between">
        <div class="log" @click="showLog = true">查看日志</div>
        <i-switch
          v-model="isOpen"
          @on-change="changeSwitch"
          size="small"
          style="margin: 8px 0 0 0"
        ></i-switch>
      </div> -->
    </div>
    <div class="des">
      <div class="serDes">
        <span class="secondTit">服务描述：</span>{{ result.description }}
      </div>
      <!-- <div>
        <span class="secondTit">更新时间：</span>{{ result.createTime }}
      </div> -->
    </div>
    <div class="first">
      <div class="tit">
        <div class="line"></div>
        基础配置
      </div>
    </div>
    <div class="des">
      <Form :label-width="120" inline>
        <FormItem label="一轮休眠时长(秒)">
          <InputNumber
            placeholder="请输入"
            :min="1"
            v-model="baseData.interval"
            clearable
          ></InputNumber>
        </FormItem>
        <FormItem label="是否打印SQL">
          <Radio-group v-model="baseData.isPrintSql">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
          </Radio-group>
        </FormItem>
        <FormItem label="日志级别">
          <Select v-model="baseData.logLevel" style="width: 200px">
            <Option
              v-for="item in LogsData"
              :value="item.key"
              :key="item.key"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
        <!-- <FormItem label="线程数">
              <Input placeholder="请输入" 
              type="number"  v-model="baseData.threadCount" clearable></Input>
            </FormItem> -->
      </Form>
      <Button class="ml-5 mr-5" type="primary" @click="updateQABaseConfig"
        >确定</Button
      >
      <Button @click="cancelEdit">重置</Button>
      <div></div>
    </div>
    <div class="second">
      <div class="tit">
        <div class="line"></div>
        QA服务基本参数
      </div>
      <div class="secOperation">
        <Form :label-width="110" inline>
          <FormItem label="设置QA地址">
            <Input
              placeholder="请输入"
              v-model="params.SendLists[0].HttpAddress"
              clearable
            ></Input>
          </FormItem>
          <FormItem label="设置QA间隔">
            <InputNumber
              placeholder="请输入"
              :min="0"
              v-model="params.Interval"
              clearable
            ></InputNumber>
          </FormItem>
          <!-- <FormItem label="设置SQL语句">
            <Input placeholder="请输入" v-model="params.SendLists.searchSql" clearable></Input>
          </FormItem>
          <FormItem label="设置图片地址">
            <Input placeholder="请输入" v-model="params.SendLists.toRisImageCountHttpAddress" clearable></Input>
          </FormItem> -->
          <FormItem label="医疗机构">
            <CheckboxGroup v-model="hosList" @on-change="checkAllGroupChange">
              <Checkbox
                :label="item.organCode"
                v-for="item in organList"
                :key="item.organCode"
              >
                <span>{{ item.organName }}</span>
              </Checkbox>
            </CheckboxGroup>
          </FormItem>
        </Form>
        <div class="btnGroup">
          <Button class="cancel" @click="clear">重置</Button>
          <Button type="primary" @click="save">保存</Button>
        </div>
      </div>
    </div>
    <Modal
      v-model="showLog"
      title="QA服务日志"
      :footer-hide="true"
      :width="1000"
    >
      <log v-if="showLog" @close="showLog = false" :from="'qa'"></log>
    </Modal>
  </div>
</template>
<script>
import log from "./log.vue";
export default {
  components: { log },
  data() {
    return {
      Status: null,
      timer: null,
      LogsData: [],
      baseData: {},
      oldBaseData: {},
      serviceSign: "",
      params: {
        SendLists: [],
        // SendLists[0].HospitalCode:''
      },
      showLog: false,
      hosList: [],
      organList: [],
      result: {},
      isOpen: 10,
    };
  },
  methods: {
    updateQABaseConfig() {
      this.$api
        .post("dictionary/updateQABaseConfig", {
          ...this.baseData,
          isPrintSql: this.baseData.isPrintSql == 1 ? true : false,
        })
        .then((res) => {
          if (res.statusCode == "200") {
            this.$Message.success("修改成功");
            this.getQABaseConfig();
          }
        });
    },
    cancelEdit() {
      // this.baseData = this.oldBaseData;
      // this.baseData.isPrintSql = this.baseData.isPrintSql ? 1 : 0;
      this.getQABaseConfig()
    },
    getQABaseConfig() {
      this.$api.get("dictionary/getQABaseConfig").then((res) => {
        //console.log('-------------------',res);
        this.baseData = res.data;
        this.baseData.isPrintSql = this.baseData.isPrintSql ? 1 : 0;
        this.oldBaseData = JSON.parse(JSON.stringify(this.baseData));
        console.log(this.baseData);
      });
    },

    checkAllGroupChange(val) {
      this.params.SendLists[0].HospitalCode = val.join("|");
    },
    getOrganList() {
      this.$api.get(`organ/GetAllOrganData`).then((rsp) => {
        console.log(rsp);
        if (rsp != false) {
          this.organList = rsp.data;
        }
      });
    },
    save() {
      // this.params.SendLists[0].HttpAddress=this.params.HttpAddress
      // this.params.SendLists[0].SendLists[0].HospitalCode =this.params.SendLists[0].HospitalCode
      console.log("---", this.params);
      this.$api
        .post(`dictionary/updateQAServerListParams`, {
          ...this.params,
        })
        .then((res) => {
          if (res.statusCode == "200") {
            this.$Message.success(res.msg);
          }

          this.getData();
        });
    },
    clear() {
      this.getData();
    },
    changeSwitch(val) {
      this.isOpen = val;
      this.$api
        .post("dictionary/updateServiceStatus", {
          serviceSign: this.serviceSign,
          serviceStatus: this.isOpen,
        })
        .then((res) => {
          if (!res) {
            this.isOpen = !this.isOpen;
            this.Status = this.result.serviceStatus;
            this.timer = setInterval(() => {
              this.getServiceInfo();
            }, 10000);
          } else {
            this.getServiceInfo();
          }
        });
    },
    getServiceInfo() {
      this.$api
        .get(`dictionary/getServiceInfo`, {
          serviceSign: "ProcessSendImageToRIS",
        })
        .then((res) => {
          this.serviceSign = res.data.serviceSign;
          this.result = res.data;
          if (this.Status !== res.data.serviceStatus) {
            clearInterval(this.timer);
          }
          this.isOpen = res.data.serviceStatus === 10;
        });
    },
    getData() {
      this.$api.get(`dictionary/getQAServer`).then((res) => {
        this.params = Object.assign({}, JSON.parse(res.data.serviceParams));
        this.hosList = this.params.SendLists[0].HospitalCode.split("|");
        console.log(this.params);
      });
    },
    refresh() {
      this.getServiceInfo();
      this.getData();
    },
  },
  created() {
    this.LogsData = this.$parent.LogsData;
  },
  mounted() {
    this.getQABaseConfig();
    this.getServiceInfo();
    this.getData();
    this.getOrganList();
  },
};
</script>
<style scoped lang="scss">
.scpPage {
  color: #333;
  .secondOperation {
    display: flex;
    justify-content: space-between;
    .status {
      width: 74px;
      height: 74px;
      background: rgba(0, 168, 112, 0.1);
      border-radius: 50%;
      font-size: 18px;
      font-weight: 400;
      color: #00a870;
      line-height: 74px;
      text-align: center;
    }
  }
  .line {
    width: 4px;
    height: 18px;
    background: #338bff;
    margin: 0 8px 0 0;
  }
  .first {
    display: flex;
    justify-content: space-between;
    margin: 16px 0 12px 0;
    height: 32px;
    line-height: 32px;
    .tit {
      display: flex;
      align-items: center;
      font-size: 16px;
    }
    .log {
      width: 82px;
      text-align: center;
      background: #f2f7ff;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #338bff;
      cursor: pointer;
    }
  }
  .des {
    display: flex;
    border: 1px solid #e5e5e5;
    padding: 18px 12px;
    .serDes {
      margin: 0 24px 0 0;
    }
    .secondTit {
      color: #666666;
    }
  }
  .second {
    .tit {
      display: flex;
      margin: 26px 0 12px 0;
    }
    .secOperation {
      border: 1px solid #e5e5e5;
      padding: 12px;
      .btnGroup {
        .cancel {
          margin: 0 12px 0 90px;
        }
      }
    }
  }
}
// /deep/ .ivu-input-number{
//   width: 180px;
// }
</style>
<style>
.scpPage .ivu-form-item {
  margin-bottom: 12px;
}
</style>